import styled from 'styled-components';
import { PricingPlanComponentsProps } from '~components/pricing/types';
import { MonthlyTurnoverLimit } from './monthly-turnover-limit';
import { PricingFeature } from './pricing-feature';

type FeatureListProps = {
    features: string[];
    hasDivider: boolean;
    isBulletPlus: boolean;
    paymentsUpTo: string;
} & PricingPlanComponentsProps;

export const FeatureList = ({
    currency,
    features,
    hasDivider,
    isBulletPlus,
    language,
    paymentsUpTo,
    tier,
}: FeatureListProps) => {
    return (
        <ListOfFeatures>
            {hasDivider && <ListDivider />}

            {/* showing feature with monthly turnover limit */}
            <PricingFeature
                feature={paymentsUpTo}
                isBulletPlus={isBulletPlus}
            />
            {paymentsUpTo && (
                <MonthlyTurnoverLimit
                    tier={tier}
                    currency={currency}
                    language={language}
                />
            )}

            {features.map((feature, index) => (
                <PricingFeature
                    key={index}
                    feature={feature}
                    isBulletPlus={isBulletPlus}
                />
            ))}
        </ListOfFeatures>
    );
};

const ListOfFeatures = styled.ul`
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 29px;
    letter-spacing: -0.25px;
    padding-left: 20px;
    position: relative;
`;

const ListDivider = styled.li`
    list-style: none;
    width: calc(100% + 20px);
    margin: 15px 0 15px -20px;
    border: ${({ theme }) => theme.listDividerBorder};
    border-radius: 5px;
`;
